<template>
  <footer :class="[{ 'svip': issvip }, 'footer']">
    <div class="footer-line1 home">
      <div class="footer-logo ">
        <img v-if="issvip" src="@/assets/sviplogo.png" alt="熊猫在学">
        <img v-else src="@/assets/logo.png" alt="熊猫在学">
      </div>
      <div class="footer-column-title sjmt" style="margin-left: 20px; margin-right: 20px;">社交媒体</div>
      <ul class="social-icons">
        <li>
          <img @mouseenter="showCode = 'douyin'" @mouseleave="showCode = ''"
            :src="issvip ? require('@/assets/images/membership/douyin.png') : require('@/assets/images/footer/douyin.png')"
            alt="抖音">
          <div class="qrcode-popup" v-show="showCode === 'douyin'">
            <div class="popup-title">扫码关注官方抖音号</div>
            <img src="@/assets/images/footer/dy.png" alt="抖音二维码">
          </div>
        </li>
        <li>
          <img @mouseenter="showCode = 'redbook'" @mouseleave="showCode = ''"
            :src="issvip ? require('@/assets/images/membership/redbook.png') : require('@/assets/images/footer/redbook.png')"
            alt="小红书">
          <div class="qrcode-popup" v-show="showCode === 'redbook'">
            <div class="popup-title">扫码关注官方小红书号</div>
            <img src="@/assets/images/footer/xhs.png" alt="小红书二维码">
          </div>
        </li>
        <li>
          <img @mouseenter="showCode = 'shipinghao'" @mouseleave="showCode = ''"
            :src="issvip ? require('@/assets/images/membership/shipinghao.png') : require('@/assets/images/footer/shipinghao.png')"
            alt="视频号">
          <div class="qrcode-popup" v-show="showCode === 'shipinghao'">
            <div class="popup-title">扫码关注官方视频号</div>
            <img src="@/assets/images/footer/sph.png" alt="视频号二维码">
          </div>
        </li>
      </ul>
    </div>

    <div class="footer-inner home">
      <div class="footer-column">
        <div class="footer-column-title">关于我们</div>
        <ul :class="{ 'footer-li': issvip }">
          <li><router-link to="/about">核心优势</router-link></li>
          <li><router-link to="/about">融资计划</router-link></li>
          <li><router-link to="/about">用户反馈</router-link></li>
        </ul>
      </div>
      <div class="footer-column">
        <div class="footer-column-title">应用</div>
        <ul :class="{ 'footer-li': issvip }">
          <li><router-link to="/download">Android 版</router-link></li>
          <li><a href="https://apps.apple.com/cn/app/%E7%86%8A%E7%8C%AB%E5%9C%A8%E5%AD%A6/id1586421154">IOS
              版</a></li>
          <li><router-link to="/download">学习机 版</router-link></li>
        </ul>
      </div>
      <div class="footer-column">
        <div class="footer-column-title">隐私及条款</div>
        <ul :class="{ 'footer-li': issvip }">
          <li><a href="https://pandaxuequ.com.cn/agreement/Private.html" target="_blank">隐私政策</a></li>
          <li><a href="https://pandaxuequ.com.cn/agreement/Service.html" target="_blank">用户协议</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <div class="footer-column-title">联系我们</div>
        <ul :class="{ 'footer-li': issvip }">
          <li><a><img style="width: 100px;height: 100px;" src="@/assets/images/footer/wx.jpg" alt="企微二维码"></a>
          </li>

        </ul>
      </div>

    </div>
    <div class="copyright">
      <p>©盘达学趣（武汉）科技有限公司</p>
      <p>鄂ICP备: 鄂B2-20200287 | 鄂ICP备19017498号</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter',
  data() {
    return {
      showCode: '', // 用于标识显示哪个平台的二维码，空表示都不显示
      issvip: false
    }
  },
  watch: {
    $route() {
      this.issvip = this.$route.path.indexOf('membership') > -1
      console.log(this.issvip)
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.footer {
  background-color: #F8F8F8;
  padding: 40px 20px;
  color: rgba(51, 51, 51, 1);
}

.svip {
  background-color: rgba(203, 152, 255, 1);
  color: #fff;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* max-width: 1200px; */
  margin: 0 auto;
}

.footer-column {
  width: 220px;
  margin-bottom: 30px;
}

.footer-column-title {
  font-size: 22px;
  font-family: Source Han Sans SC-Medium;
  margin-bottom: 24px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 22px;
}

.footer-column li:hover {
  color: rgba(255, 161, 15, 1);
}

.footer-column a {
  font-family: Source Han Sans SC-Regular;
  font-weight: Regular;
  font-size: 16px;
  /* color: #333333; */
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  /* color: #ff9900; */
}

.qrcode {
  text-align: center;
  margin-top: 10px;
}

.qrcode img {
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto 5px;
}

.social-icons {
  display: flex;
  margin-left: 20px;
}

.social-icons img {
  width: 42px;
  height: 42px;
  position: relative;
  z-index: 3;
}

.footer-logo img {
  width: 174px;
  height: auto;
}

.copyright {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 14px;
  /* color: #999; */
}

.social-icons li {
  position: relative;
  cursor: pointer;
  margin-right: 100px;
}

.qrcode-popup {
  position: absolute;
  bottom: 11px;
  left: -259%;
  width: 258px;
  height: 314px;
  background: url('@/assets/images/footer/qrbg.png') no-repeat center;
  background-size: 100% 100%;
  z-index: 2;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

/* .qrimg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
} */

.qrcode-popup img {
  margin: 16px auto;
  width: 159px;
  height: 159px;
}

.popup-title {
  margin-top: 48px;
}

.footer-li li:hover {
  color: #450E2E;
}

.footer-line1 {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.sjmt {
  margin-bottom: 0px;
}

@media screen and (max-width: 767px) {
  .footer-column-title {
    font-size: 12px;
  }

  .footer-column a {
    font-size: 10px;
  }

  .social-icons img {
    width: 26px;
    height: 25px;
  }

  .footer-logo img {
    width: 73px;
    height: 22px;
  }

  .qrcode-popup {
    position: absolute;
    bottom: 11px;
    left: -340%;
    width: 200px;
    height: 230px;
  }

  .qrcode-popup img {
    margin: 10px auto;
    width: 123px;
    height: 123px;
  }

  .popup-title {
    margin-top: 38px;
    font-size: 10px;
  }

  .footer-column {
    width: 25%;
    margin-bottom: 30px;
  }
}
</style>
